import React from "react"
import { Link } from "react-router-dom"
import NewsoftLogo from "../../assets/images/logo_newsoft.svg"
import { SOCIAL_MEDIA } from "../../constants/links"
import { TeamAugmentationRoute, TryNowRoute, OrbitRoute, QuarkworksRoute, ITConsultingAndAdvisoryRoute } from "../../routes"
import LinkedinIcon from "../../assets/images/social_media/LinkedinIcon.svg"
import InstaIcon from "../../assets/images/social_media/InstaIcon.svg"
import FacebookIcon from "../../assets/images/social_media/FacebookIcon.svg"
import YouTubeIcon from "../../assets/images/social_media/YoutubeIcon.svg"
import ClutchIcon from "../../assets/images/social_media/ClutchIcon.svg"

import "./index.scss"
import { NAVIGATION_LINKS } from "../../constants/common"

const Footer = () => {
    return (
        <div className="footer">
            <hr className="footer-divider-mobile"/>
            <div className="footer-content">
                <div className="footer-content-icons">
                    <div className="footer-content-icons-logo">
                        <img src={NewsoftLogo} alt="Newsoft logo"></img>
                    </div>
                    <div className="footer-content-icons-social">
                        <Link
                            className="hov-icon"
                            to={SOCIAL_MEDIA.LinkedIn}
                            target="_blank"
                            rel="preload"
                        >
                            <img src={LinkedinIcon} alt="Linkedin logo"/>
                        </Link>
                        <Link
                            className="hov-icon"
                            to={SOCIAL_MEDIA.Instagram}
                            target="_blank"
                            rel="preload"
                        >
                            <img src={InstaIcon} alt="Instagram logo"/>
                        </Link>
                        <Link 
                            className="hov-icon"
                            to={SOCIAL_MEDIA.YouTube}
                            target="_blank"
                            rel="preload"
                        >
                            <img src={YouTubeIcon} alt="Youtube logo"/>
                        </Link>
                        <Link
                            className="hov-icon"
                            to={SOCIAL_MEDIA.Facebook}
                            target="_blank"
                            rel="preload"
                        >
                            <img src={FacebookIcon} alt="Facebook logo"/>
                        </Link>
                        <Link
                            className="hov-icon"
                            to={SOCIAL_MEDIA.Clutch}
                            target="_blank"
                            rel="preload"
                        >
                            <img src={ClutchIcon} alt="Clutch logo"/>
                        </Link>
                    </div>
                </div>
                <hr className="footer-content-vertical" />
                <div className="footer-content-navigation">
                    <div className="footer-content-navigation-block">
                        <div className="footer-content-navigation-block-info">
                            <p className="footer-content-navigation-block-info-title t-s5">
                                Services
                            </p>
                            <Link
                                to={TeamAugmentationRoute.path}
                                className="footer-content-navigation-block-info-link t-b4"
                            >
                                Team Augmentation
                            </Link>
                            <Link
                                to={ITConsultingAndAdvisoryRoute.path}
                                className="footer-content-navigation-block-info-link t-b4"
                            >
                                IT Consulting & Advisory Services
                            </Link>
                        </div>
                    </div>
                    <hr className="footer-content-vertical-small" />
                    <div className="footer-content-navigation-block">
                        <div className="footer-content-navigation-block-info">
                            <p className="footer-content-navigation-block-info-title t-s5">
                                Our cases
                            </p>
                            <Link
                                to={TryNowRoute.path}
                                className="footer-content-navigation-block-info-link t-b4"
                            >
                                TryNow
                            </Link>
                            <Link
                                to={QuarkworksRoute.path}
                                className="footer-content-navigation-block-info-link t-b4"
                            >
                                Quarkworks
                            </Link>
                            <Link
                                to={OrbitRoute.path}
                                className="footer-content-navigation-block-info-link t-b4"
                            >
                                Orbit
                            </Link>
                        </div>
                    </div>
                    <hr className="footer-content-vertical-small" />
                    <div className="footer-content-navigation-block">
                        <div className="footer-content-navigation-block-info">
                            <p className="footer-content-navigation-block-info-title t-s5">
                                About us
                            </p>
                            <Link
                                to={NAVIGATION_LINKS.ABOUT_US}
                                className="footer-content-navigation-block-info-link t-b4"
                            >
                                Meet our team
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
            <hr />
            <div className="footer-copyright">
                <p className="t-b4">© 2019-2023 Newsoft |  </p> 
                <Link className="t-b4" to={NAVIGATION_LINKS.PRIVACY_POLICY}>&nbsp;Privacy Policy</Link>
            </div>
        </div>
    )
}

export default Footer
